'use es6';

import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import PortalIdParser from 'PortalIdParser';
import { useTracker } from '../../utils/hooks/useTracker';
import { EVENTS } from '../../utils/usageTracker';
import UpgradePointButton from '../shared/upgradePoints/AsyncUpgradePointButton';
import { UPGRADE_POINT_LOCATION_VALUES } from '../shared/upgradePoints/upgradePointKeys';
import ActionButton from '../ActionButton';
import useCreateDashboardProblem from './useCreateDashboardProblem';
import { jsx as _jsx } from "react/jsx-runtime";
const DiscoverDashboardsButton = ({
  appUsageTracker,
  dashboardId,
  disabled: isDisabledViaParentApp = false,
  label = /*#__PURE__*/_jsx(FormattedMessage, {
    message: "reporting-action-components.actions.createDashboard.button.text"
  }),
  showOnDisable = true,
  tooltipMessage: appDefinedTooltip,
  tooltipPlacement,
  upgradeLocation,
  size,
  use
}) => {
  const usageTracker = useTracker(appUsageTracker);
  const {
    problem,
    disabledMessage,
    upgradeKey
  } = useCreateDashboardProblem({
    upgradeLocation
  });
  const isDisabled = isDisabledViaParentApp || !!problem;
  const handleClick = () => {
    if (usageTracker) {
      usageTracker.track(EVENTS.clickCreateAsset, {
        actionType: 'create',
        action: 'create',
        assetType: 'dashboard'
      });
    }

    //TODO ideally, the dashboardId param shouldn't be necessary within discover
    const queryParams = dashboardId ? `?dashboardId=${dashboardId}` : '';
    window.location = `/discover/${PortalIdParser.get()}/create/dashboards${queryParams}`;
  };
  if (isDisabled && !showOnDisable) {
    return null;
  }
  if (upgradeKey) {
    return /*#__PURE__*/_jsx(UpgradePointButton, {
      label: label,
      upgradeKey: upgradeKey,
      dataTestId: "discover-dashboards-action-upgrade",
      size: size,
      use: "secondary"
    });
  }
  return /*#__PURE__*/_jsx(ActionButton, {
    dataTestId: "discover-dashboards-action",
    label: label,
    disabled: isDisabled,
    tooltip: appDefinedTooltip || disabledMessage,
    tooltipPlacement: tooltipPlacement,
    onClick: handleClick,
    size: size,
    use: use
  });
};
DiscoverDashboardsButton.propTypes = {
  appUsageTracker: PropTypes.object.isRequired,
  dashboardId: PropTypes.number,
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.element,
  showOnDisable: PropTypes.bool,
  tooltipMessage: PropTypes.node,
  tooltipPlacement: PropTypes.string,
  upgradeLocation: PropTypes.oneOf(UPGRADE_POINT_LOCATION_VALUES)
};
export default DiscoverDashboardsButton;